<template>
  <div id="homeView">
    <!--顶部导航 logo 登录注册 用户信息-->
    <topNav />
    <!--顶部场景规则库定制-->
    <ruleListView ref="ruleListView" @ruleParentReceive="ruleParentReceiveFN"/>
     <!--右侧悬浮-->
    <floatRightView v-if="false" />

    <!--切换路由-->
    <router-view :key="$route.fullPath" />
    <!--底部导航 网站版权信息 -->
    <footertView />
  </div>
</template>
<script>

//引入组件
import topNav from '@/components/topNav.vue'
import footertView from '@/components/footerView.vue'
import ruleListView from '@/components/ruleList.vue'
import floatRightView from '@/components/floatRight.vue'


export default {
  name:'home',
  components:{
    topNav,
    footertView,
    ruleListView,
    floatRightView
  },
  created(){
    //console.log(this.$route.query.path,'咋咋咋咋咋咋咋咋阿哲')
  },
  methods:{
    //场景规则库的选择 -- 子组件传递
    ruleParentReceiveFN(data){
      this.bottomShow = 'loading';
      this.sendZsgObj = {}
      this.sendZsgObj.path = data.type
      setTimeout(() => {
        this.bottomShow = data.type;
      },10)
    },
  }
}
</script>
<style lang="scss">
#homeView{
    background: #F5F5F5;
}
/***底部内容 start */
.bottomView{
    width:1200px;
    margin:0 auto;
    /*overflow: hidden;*/
    margin-top:15px;
}
/***底部内容 end */
</style>
